import { useMemo, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { useResponsive } from '@shared/hooks';
import { PaletteUtils } from '@shared/utils';
import { MessagesMenuItem } from './messageMenuItem';
import { DropDownIcon } from '@shared/widgets';

interface NavProps {
  onClick?: () => void;
}

export const Nav = (props: NavProps) => {
  const location = useLocation();

  const [openItems, setOpenItems] = useState<Record<string, boolean>>({});

  const { isMobile } = useResponsive();
  const { t } = useTranslation();

  const toggleGroupHandler = (item: any) => setOpenItems((prev) => ({ ...prev, [item.url]: !prev[item.url] }));

  const isCardsActive = (url: string, exact?: boolean) => {
    if (url === '/') return location.pathname === '/' || location.pathname.startsWith('/card');
    return exact ? location.pathname === url : location.pathname.startsWith(url);
  };

  const menu = useMemo(
    () => [
      { caption: t('nav.menu.myCards'), url: '/', exact: true },
      {
        caption: t('nav.menu.myProfile'),
        url: '/profile',
        items: [
          { caption: t('nav.menu.personalDetails'), url: '/profile', exact: true },
          { caption: t('nav.menu.changePassword'), url: '/profile/password', exact: true },
        ],
      },
      { caption: <MessagesMenuItem />, url: '/messages' },
    ],
    [t],
  );

  return (
    <div className='flex flex-row flex-nowrap h-[70px] whitespace-nowrap max-[840px]:order-1 max-[840px]:h-auto max-[840px]:w-full max-[840px]:flex-col max-[840px]:mb-auto'>
      {menu.map((item, idx) => {
        if (item.items && isMobile) {
          const isOpen = !!openItems[item.url];
          return (
            <div key={idx} className={clsx('border-b-[#3c3c40]')}>
              <div
                className={clsx(
                  'text-sm uppercase font-bold flex justify-between w-full leading-[48px] border-b border-b-[#3c3c40]  h-auto items-center px-[22px]',
                  PaletteUtils.isBordierPalette ? 'text-[#4d3b2c]' : 'text-[#dadada]',

                  PaletteUtils.isBordierPalette ? 'border-l-[#dc291c]' : 'border-none',
                )}
                onClick={() => toggleGroupHandler(item)}
              >
                {item.caption}
                <DropDownIcon className='block !h-2 -mt-1 !w-4' isOpen={isOpen} />
              </div>
              {isOpen &&
                item.items.map((item, idx) => (
                  <NavLink
                    key={idx}
                    className={({ isActive }) =>
                      clsx(
                        'text-sm  uppercase font-bold flex justify-between w-full leading-[48px]  border-b border-b-[#3c3c40] text-[#4d3b2c] h-auto px-[22px]',
                        PaletteUtils.isBordierPalette ? 'text-[#4d3b2c]' : 'text-[#dadada]',
                        isActive &&
                          (PaletteUtils.isBordierPalette
                            ? 'max-[840px]:bg-[#1e1e21] max-[840px]:!text-white max-[840px]:border-l-2 max-[840px]:border-l-[#dc291c] bg-[#dc291c] text-white  hover:text-white'
                            : 'bg-[#27272b] text-[#e5c496]'),
                      )
                    }
                    to={item.url}
                    end={item.exact}
                    onClick={props.onClick}
                  >
                    {item.caption}
                  </NavLink>
                ))}
            </div>
          );
        }

        const active = isCardsActive(item.url, item.exact);

        return (
          <NavLink
            key={idx}
            className={clsx(
              'inline-block h-full text-[14px] px-[27px] uppercase leading-[70px] font-bold max-[840px]:leading-[48px] max-[840px]:border-b max-[840px]:border-b-[#3c3c40]  max-[840px]:px-[22px]',
              PaletteUtils.isBordierPalette ? 'hover:text-[#dc291c] max-[840px]:text-[#4d3b2c]' : 'text-[#dadada] hover:text-[#e5c496]',
              active &&
                (PaletteUtils.isBordierPalette
                  ? 'max-[840px]:bg-[#1e1e21] max-[840px]:!text-white max-[840px]:border-l-2 max-[840px]:border-l-[#dc291c] bg-[#dc291c] text-white  hover:text-white'
                  : 'bg-[#27272b] text-[#e5c496]'),
            )}
            to={item.url}
            end={item.exact}
            onClick={props.onClick}
          >
            {item.caption}
          </NavLink>
        );
      })}
    </div>
  );
};
